<template>
  <div>
    <FilterTab>
      <template v-slot:body>
        <div class="col-sm-6 col-md-3">
          <DropdownFilter
            v-bind:id="'from'"
            v-bind:label="'From Stoppage'"
            v-bind:defaultOption="'--select stoppage--'"
            v-model="pagination.from"
            v-bind:defaultValue="''"
            v-bind:dropdown="$store.getters.getCountermanStoppageListForFilter"
          />
        </div>
        <div class="col-sm-6 col-md-3">
          <DropdownFilter
            v-bind:id="'to'"
            v-bind:label="'To Stoppage'"
            v-bind:defaultOption="'--select stoppage--'"
            v-model="pagination.to"
            v-bind:defaultValue="''"
            v-bind:dropdown="$store.getters.getCountermanStoppageListForFilter"
          />
        </div>
        <div class="col-sm-6 col-md-3">
          <DropdownFilter
            v-bind:id="'ship'"
            v-bind:label="'Ship'"
            v-bind:defaultOption="'--select ship--'"
            v-model="pagination.ship"
            v-bind:defaultValue="''"
            v-bind:dropdown="$store.getters.getCountermanShipListForFilter"
          />
        </div>
        <div class="col-sm-6 col-md-3">
          <DatePickerFilter
            v-bind:id="'datePickerDate'"
            v-bind:label="'Date'"
            v-model="pagination.date"
          />
        </div>
        <!--                <div class="col-sm-6 col-md-2">-->
        <!--                    <DropdownFilter v-bind:id="'status'" v-bind:label="'Status'"-->
        <!--                                    v-bind:defaultOption="'&#45;&#45;select status&#45;&#45;'"-->
        <!--                                    v-model="pagination.status"-->
        <!--                                    v-bind:defaultValue="''"-->
        <!--                                    v-bind:dropdown="status"/>-->
        <!--                </div>-->
      </template>
    </FilterTab>
    <div v-if="dashboardActive">
      <div v-if="$store.getters.getTripsForTicketing" class="table-responsive">
        <table
          class="table table-hover table-striped text-center vehicle_table"
        >
          <thead class="font_detail bg_corporate">
            <tr>
              <td class="font_detail">SL</td>
              <td class="font_detail">TRIP TIME & DATE</td>
              <td class="font_detail">TRIP CODE</td>
              <td class="font_detail">SHIP</td>
              <td class="font_detail">ROUTE</td>
              <td class="font_detail">DIRECTION</td>
              <td class="font_detail">DECK FARE</td>
              <td class="font_detail">STATUS</td>
              <td
                class="font_detail"
                v-if="hasPermission(Counterman.countermanTicketCancel)"
              >
                TICKET
              </td>
              <td
                class="font_detail"
                v-if="
                  hasPermission(Counterman.counterReservation) ||
                  reservationStatus
                "
              >
                RESERVATION
              </td>
              <td class="font_detail">ACTION</td>
            </tr>
          </thead>
          <tbody
            v-for="(trip, index) in $store.getters.getTripsForTicketing"
            :key="trip._id"
          >
            <tr>
              <td class="font_detail">{{ index + 1 }}</td>
              <td class="font_detail bold">{{ dateFormat(trip.tripDate) }}</td>
              <td class="font_detail">{{ trip.tripCode }}</td>
              <td class="font_detail bold">{{ trip.ship.name }}</td>
              <td class="font_detail">{{ trip.route.name }}</td>
              <td class="font_detail bold">
                {{ trip.direction }}<br />{{ trip.fromStoppage.name }} -
                {{ trip.toStoppage.name }}
              </td>
              <td class="font_detail">{{ trip.deckFare }}</td>
              <td>
                <span
                  class="badge"
                  :class="
                    'bg-' + dropdownVariables.tripStatus[trip.status].badge
                  "
                  >{{ dropdownVariables.tripStatus[trip.status].value }}</span
                >
              </td>
              <td
                class="font_detail bold"
                v-if="hasPermission(Counterman.countermanTicketCancel)"
              >
                <button
                  class="btn btn-warning btn-sm"
                  @click="Tickets(trip._id)"
                >
                  <span class="mx-1">Cancel</span>
                </button>
              </td>
              <td
                class="font_detail bold"
                v-if="
                  hasPermission(Counterman.counterReservation) ||
                  reservationStatus
                "
              >
                <button
                  class="btn btn-dark btn-sm"
                  @click="ReservedTickets(trip._id)"
                >
                  <span class="mx-1">Details</span>
                </button>
              </td>
              <td>
                <button
                  v-if="activeTrip !== trip._id"
                  class="btn btn-primary btn-sm"
                  @click="
                    viewTrip(
                      trip._id,

                    )
                  "
                >
                  <i class="fas fa-chevron-down"></i
                  ><span class="mx-1">View</span>
                </button>
                <button
                  v-else
                  class="btn btn-primary btn-sm"
                  @click="viewTrip('')"
                >
                  <i class="fas fa-chevron-up"></i
                  ><span class="mx-1">Close</span>
                </button>
              </td>
            </tr>

            <tr v-if="activeTrip === trip._id">
              <td colspan="11" class="p-0">
                <TicketBooking
                  v-bind:tripId="activeTrip"
                  :tripDetails="tripDetails"
                  :paginationData="pagination"
                  @seatPlanTab="activeSeatPlanTab"
                  :selectedSeatPlanTab=selectedSeatPlanTab
                  :selectedSeatPlanTabIndex=selectedSeatPlanTabIndex
                  :selectedFloorPlanTabIndex=selectedFloorPlanTabIndex
                  @floorPlanTab="activeFloorPlanTab"
                  :selectedFloorPlanTab=selectedFloorPlanTab
                />
              </td>
            </tr>
          </tbody>
        </table>
        <div class="row mx-5">
          <nav aria-label="Page navigation example">
            <ul
              class="pagination justify-content-center justify-content-sm-end"
            >
              <slot name="pagination"></slot>
            </ul>
          </nav>
        </div>
      </div>
    </div>

    <ReservedTicketsDetails
      v-else-if="reservationTicket"
      :tripIdPass="tripIdPass"
      :seatClassName = "seatClassName"
      :seatNumbers = "seatNumbers"
      @close="close"
      :paginationData="pagination"
    />

    <TicketsDetails
      v-else
      :tripIdPass="tripIdPass"
      :seatNumbers = "seatNumbers"
      @close="close"
      :paginationData="pagination"
    />
  </div>
</template>

<script>
import { computed, inject, onBeforeMount, ref, watch } from "vue";
import store from "@/store";
import TicketBooking from "./TicketBooking/TicketBooking";
import { reactive } from "@vue/reactivity";
import moment from "moment";
import dropdownVariables from "../../../modules/dropdownVariables";
import TicketsDetails from "./TicketBooking/TicketsDetails.vue";
import ReservedTicketsDetails from "./TicketBooking/ReservedTicketsDetails.vue";
import permission from "@/modules/permission";
import roles from "@/modules/roles";

export default {
  name: "CountermanDashboard",
  components: {
    TicketBooking,
    TicketsDetails,
    ReservedTicketsDetails,
  },
  setup() {
    let tripDetails = reactive({
      route: "",
      ship: "",
      bookingNumber: "",
      maxSeatPerTicket: null,
      direction: "",
      isDTAvailable: false,
      countermanDtExpireTime: "",
    });
    let tripIdPass = ref("");
    let dashboardActive = ref(true);
    let reservationTicket = ref(false);
    let reservationStatus = ref(false);
    let cencelTicket = ref(false);
    let pagination = reactive({
      // page: 1,
      // limit: 10,
      companyId: store.getters.userCompany,
      from: "",
      to: "",
      ship: "",
      date: moment(new Date()).format("yyyy-MM-DD"),
      status: "ACTIVE",
    });
    let activeTrip = ref("");
    const showLoader = inject("showLoader");
    const hideLoader = inject("hideLoader");
    const { hasPermission } = permission();
    const { Counterman } = roles();
    const seatClassName = ref("");
    const seatNumbers = ref("");
    const selectedSeatPlanTab = ref({});
    const selectedFloorPlanTab = ref({});
    const selectedSeatPlanTabIndex = ref(0);
    const selectedFloorPlanTabIndex = ref(0);
    const selectedTrip = ref({});
    const selectedTripId = ref('');

    // watch(() => pagination.status, () => {
    //     getAllTripsForTicketing()
    // });
    watch(
      () => pagination.from,
      () => {
        activeSeatPlanTab('')
        getAllTripsForTicketing();
      }
    );
    watch(
      () => pagination.to,
      () => {
        activeSeatPlanTab('')
        getAllTripsForTicketing();
      }
    );
    watch(
      () => pagination.date,
      () => {
        activeSeatPlanTab('')
        getAllTripsForTicketing();
      }
    );
    watch(
      () => pagination.ship,
      () => {
        activeSeatPlanTab('')
        getAllTripsForTicketing();
      }
    );

    watch(() => store.getters.getTripsForTicketing, ( ) => {
      if(selectedTripId.value){
        selectedTrip.value = store.getters.getTripForTicketing(selectedTripId.value)[0];
        if(selectedTrip.value){
          initSelectedTripData(selectedTrip.value)
        }
      }
    },{
      deep: true
    })

    const status = computed(() => {
      let allTripStatus = {};
      for (let [key, value] of Object.entries(dropdownVariables.tripStatus)) {
        allTripStatus[key] = value.value;
      }
      return allTripStatus;
    });

    const viewTrip = (
      tripId,
    ) => {
      if (tripId) {
        selectedTripId.value = tripId;
        getAllTripsForTicketing(tripId);
        activeSeatPlanTab('')
      }else {
        activeTrip.value = ''
        selectedTripId.value = ''
      }
    };
    const initSelectedTripData = (trip) => {
      tripDetails.route = trip.route.name;
      tripDetails.ship = trip.ship.name;
      tripDetails.bookingNumber = trip.ship.bookingNumber;
      tripDetails.maxSeatPerTicket = trip.companyId.maxSeatPerTicket;
      tripDetails.direction = trip.direction;
      tripDetails.isDTAvailable = trip.isDTAvailable;
      tripDetails.countermanDtExpireTime = trip.countermanDtExpireTime;
    }
    const Tickets = (tripId) => {
      tripIdPass.value = tripId;
      cencelTicket.value = true;
      reservationTicket.value = false;
      dashboardActive.value = false;
    };
    const ReservedTickets = (tripId) => {
      tripIdPass.value = tripId;
      reservationTicket.value = true;
      cencelTicket.value = false;
      dashboardActive.value = false;
    };
    const dateFormat = (date) => {
      return moment(String(date))
        .utcOffset(0, false)
        .format("DD-MMM-yyyy hh:mm:ss A");
    };
    const getAllTripsForTicketing = (tripId) => {
      showLoader();
      store
        .dispatch("getActiveTripsForTicketing", pagination)
        .then(() => {
          hideLoader();
          getAllStoppages();
          getAllShips();
          initReservationStatus();
          if(tripId){
            selectedTrip.value = store.getters.getTripForTicketing(tripId)[0];
            console.log(selectedTrip.value)
            initSelectedTripData(selectedTrip.value)
            activeTrip.value = tripId;
          }
        })
        .catch((error) => {
          hideLoader();
          if (error.status === 401) {
            getAllTripsForTicketing();
          }
        });
    };
    const initReservationStatus = () => {
      reservationStatus.value =
        store.getters.getTripsForTicketing[0].companyId.reservation;
    };
    const close = () => {
      getAllTripsForTicketing();
      tripIdPass.value = "";
      dashboardActive.value = true;
    };
    const getAllStoppages = () => {
      store
        .dispatch("getStoppageListForCounterman", {})
        .then(() => {})
        .catch((error) => {
          if (error.status === 401) {
            getAllStoppages();
          }
        });
    };
    const getAllShips = () => {
      store
        .dispatch("getShipListForCounterman", {})
        .then(() => {})
        .catch((error) => {
          if (error.status === 401) {
            getAllShips();
          }
        });
    };

    const activeSeatPlanTab = (value, index) => {
      selectedSeatPlanTab.value = value;
      selectedSeatPlanTabIndex.value = index;
    }

    const activeFloorPlanTab = (value, index) => {
      selectedFloorPlanTab.value = value;
      selectedFloorPlanTabIndex.value = index;
    }

    onBeforeMount(() => {
      getAllTripsForTicketing();
    });

    return {
      activeTrip,
      dropdownVariables,
      tripIdPass,
      dashboardActive,
      reservationTicket,
      cencelTicket,
      hasPermission,
      Counterman,
      status,
      pagination,
      viewTrip,
      dateFormat,
      Tickets,
      ReservedTickets,
      reservationStatus,
      close,
      tripDetails,
      seatClassName,
      seatNumbers,
      activeSeatPlanTab,
      selectedSeatPlanTab,
      activeFloorPlanTab,
      selectedFloorPlanTab,
      selectedSeatPlanTabIndex,
      selectedFloorPlanTabIndex
    };
  },
};
</script>

<style scoped></style>
